import { theme } from "../index.js";
const getColor = (name, depth) => {
  if (name === "black" || name === "white") {
    return theme.palette[name];
  }
  if (depth) {
    return theme.palette[`${name}${depth}`];
  }
  return "";
};
const getHoverColor = (color) => `${getColor(color, 700)}0D`;
export {
  getColor,
  getHoverColor
};
//# sourceMappingURL=color.js.map
